import React from 'react';
import { Clock, Crown, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTrial } from '../hooks/useTrial';

export const TrialBanner: React.FC = () => {
  const navigate = useNavigate();
  const { trialStatus, isTrialActive, daysLeft } = useTrial();

  // Don't show banner if user has full access (paid subscription)
  if (!trialStatus || trialStatus.hasFullAccess) {
    return null;
  }

  // Don't show if trial is expired (paywall will be shown instead)
  if (!isTrialActive) {
    return null;
  }

  const getBannerStyle = () => {
    if (daysLeft <= 1) {
      return 'bg-red-50 border-red-200 text-red-800';
    } else if (daysLeft <= 3) {
      return 'bg-orange-50 border-orange-200 text-orange-800';
    }
    return 'bg-blue-50 border-blue-200 text-blue-800';
  };

  const getIcon = () => {
    if (daysLeft <= 1) {
      return <AlertTriangle className="h-5 w-5" />;
    }
    return <Clock className="h-5 w-5" />;
  };

  return (
    <div className={`mb-6 p-4 rounded-lg border ${getBannerStyle()}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {getIcon()}
          <div className="ml-3">
            <p className="font-semibold">
              {daysLeft === 0 
                ? 'Ihre kostenlose Testphase endet heute!' 
                : `Noch ${daysLeft} ${daysLeft === 1 ? 'Tag' : 'Tage'} in Ihrer kostenlosen Testphase`
              }
            </p>
            <p className="text-sm mt-1 opacity-90">
              Genießen Sie weiterhin alle Premium-Features mit einem unserer Pläne
            </p>
          </div>
        </div>
        
        <button
          onClick={() => navigate('/qr/pricing')}
          className="flex items-center px-4 py-2 bg-white rounded-lg font-semibold hover:bg-gray-50 transition-colors border border-current"
        >
          <Crown className="h-4 w-4 mr-2" />
          Plan wählen
        </button>
      </div>
    </div>
  );
}; 